import React, { useState } from 'react';
import Modal from '../../../components/Modal/index';
import '../../../../sass/pages/account/price_modal.scss';
import trackEvent from '../../../helpers/gtm/eventPush';

const ProductPrice = (props) => {
  const productRows = props.products.map((product) =>
    props.siteMobile &&
    props.page == '/content/placeditadvert/listing-options/' &&
    product.id == '1001' ? null : (
      <ProductRow
        key={product.id}
        product={product}
        currencySymbol={props.currencySymbol}
      />
    ),
  );
  return <ul className="product-price__rows">{productRows}</ul>;
};

const ProductRow = (props) => {
  const rowClassName = `product-price__row`;
  const originalPrice = props.product.original_price ? (
    <s className="product-price__original-price">
      {props.currencySymbol + props.product.original_price}
    </s>
  ) : null;
  return (
    <li className={rowClassName}>
      <div className="product-price__name">{props.product.name}</div>
      <div className="product-price__pricing">
        {originalPrice}
        <span className="product-price__price">
          {props.currencySymbol + props.product.price}
        </span>
      </div>
    </li>
  );
};

const trackPostAdButton = () => {
  trackEvent({
    category: 'ads',
    action: 'free_bold_options_see_prices_post_ad',
  });
};

const PriceModal = ({
  currencySymbol,
  subDirectory,
  products,
  siteMobile,
  customerType,
  page,
}) => {
  const [showDialog, updateShowDialog] = useState(false);

  const close = () => {
    updateShowDialog(false);
  };

  const open = () => {
    updateShowDialog(true);
  };

  const modalLabelTextPrice = <span>Bold Ad upgrade prices</span>;

  return (
    <>
      {showDialog ? (
        <Modal
          close={close}
          showDialog={showDialog}
          modalLabelText={modalLabelTextPrice}
          id="price-modal"
          initialFocus=".modal__close"
        >
          <div className="price-modal">
            <ProductPrice
              products={products.personal}
              currencySymbol={currencySymbol}
              siteMobile={siteMobile}
              customerType={customerType}
              page={page}
            ></ProductPrice>
            <span className="modal__price-button">
              <a
                href={`/${subDirectory}/find-postcode3.pl?desc=Bold+Advert&amount=10&scp=N`}
                className="button"
                id="modalPriceButton"
                onClick={trackPostAdButton}
              >
                Post a Bold Ad
              </a>
            </span>
          </div>
        </Modal>
      ) : null}
      <button onClick={open} className="button button--link" type="button">
        See prices
      </button>
    </>
  );
};

export default PriceModal;
